import { render, staticRenderFns } from "./MainERC.vue?vue&type=template&id=679caf8b&"
import script from "./MainERC.vue?vue&type=script&lang=js&"
export * from "./MainERC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports